<template>
  <Button
    :label="label"
    :loading="loading"
    :type="type"
    :icon="icon"
    :class="classStyle"
    style="border-radius: 0.3rem;"
    :badge="badgeText"
    :badge-class="badgeClass"
    :disabled="disabled"
  />
</template>

<script lang="ts">
import {
  defineComponent,
} from 'vue';
import Button from 'primevue/button';

export default defineComponent({
  name: 'SpmButton',

  components: {
    Button,
  },

  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },

    type: {
      type: String,
      required: false,
      default: 'button',
    },

    icon: {
      type: String,
      required: false,
      default: '',
    },

    loading: {
      type: Boolean,
      required: false,
      default: false,
    },

    classStyle: {
      type: String,
      required: false,
      default: '',
    },

    badgeText: {
      type: String,
      required: false,
      default: '',
    },

    badgeClass: {
      type: String,
      required: false,
      default: '',
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  setup(props) {
    return {
    };
  },
});
</script>

<style lang="scss">
  .p-button {
    .p-badge {
      color: $brand-color-primary;

      &.p-badge-success {
        background: $brand-color-primary;
        color: $white;
      }
    }
  }
  .ai-layout {
    width: auto;
    border: 3px solid $solitude;
    color: $columnsWidgetLayoutColor;
    border-radius: 10px;
    padding: 15px 10px;
    cursor: pointer;
    .ai-layout-icon {
      font-size:25px;
    }
    &:hover {
      border: 3px solid transparent!important;
      background: linear-gradient(#fff, #fff) padding-box, linear-gradient(167deg, rgba(148,200,64,1) 0%, rgba(0,153,120,1) 50%, rgba(0,114,142,1) 100%) border-box!important;
      color:#009978!important;
    }

    &.active {
      border: 3px solid transparent;
      background: linear-gradient(#fff, #fff) padding-box, linear-gradient(167deg, rgba(148,200,64,1) 0%, rgba(0,153,120,1) 50%, rgba(0,114,142,1) 100%) border-box;
      color:#009978;
    }
  }
</style>
